module.exports = __webpack_public_path__ + "img/番外_开国大典_01_开场.32ffe2f2.png";